<template>
    <div class="login-page">
        <div class="layer bg" id="login"></div>
        <div class="layer flex-center">
            <!-- logo部分 -->
            <div class="logo-group">
                <img src="https://cdn.heanny.cn/heanny.png" alt="logo">
            </div>
            <!-- 表单部分 -->
            <div class="form-group">
                <el-card>
                    <el-form ref="loginForm" label-position="top" :rules="rules" :model="formLogin" size="default">
                        <el-form-item prop="username">
                            <el-input type="text" v-model="formLogin.username" placeholder="用户名">
                                <i slot="prepend" class="fa fa-user-circle-o"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="formLogin.password" placeholder="密码">
                                <i slot="prepend" class="fa fa-keyboard-o"></i>
                            </el-input>
                        </el-form-item>
                        <el-button size="default" @click="submit" type="primary" class="button-login"
                                   :loading="logLoading">登录
                        </el-button>
                    </el-form>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    require('particles.js')
    import config from './config/default'
    import {mapActions} from 'vuex'


    export default {
        data() {
            return {
                // 快速选择用户
                logLoading: false,
                dialogVisible: false,
                // 表单
                formLogin: {
                    username: '',
                    password: '',
                },
                // 校验
                rules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted() {
            // 初始化例子插件
            particlesJS('login', config)
        },
        beforeDestroy() {
            // 销毁 particlesJS
            // thanks https://github.com/d2-projects/d2-admin/issues/65
            // ref https://github.com/VincentGarreau/particles.js/issues/63
            if (pJSDom && pJSDom.length > 0) {
                pJSDom[0].pJS.fn.vendors.destroypJS()
                pJSDom = []
            }
        },
        methods: {
            ...mapActions('d2admin/account', [
                'login'
            ]),
            /**
             * @description 提交表单
             */
            // 提交登录信息
            submit() {
                const _this = this
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        // 方法三，自带
                        // 登录
                        // 注意 这里的演示没有传验证码
                        // 具体需要传递的数据请自行修改代码
                        _this.logLoading = true
                        this.login({
                            vm: this,
                            // action: 'login',
                            username: this.formLogin.username,
                            password: this.formLogin.password
                        })
                    } else {
                        // 登录表单校验失败
                        this.$message.error('请输入账号')
                    }
                })
            }, keyupSubmit() {
                document.onkeydown = e => {
                    let _key = window.event.keyCode;
                    if (_key === 13) {
                        this.submit()
                    }
                }
            },
        }, created() {
            this.keyupSubmit()
        }
    }
</script>

<style lang="scss">
    @import './style.scss';
</style>
